import { useTranslation } from "react-i18next";
import { ZodIssueCode, number, object, string, unknown } from "zod";
import { AppStorage } from "../services/AppStorage";

export const useAddressFormSchema = () => {
  const { t } = useTranslation();
  const postalCodeMin = AppStorage().get("countryCode") === "PL" ? 6 : 4;

  const addressFormSchema = object({
    address: object({
      city: string().min(1, { message: t("validation.city") }),
      doorCode: string().optional().nullable(),
      floorArea: number().min(10, { message: t("validation.minSurface", { minSize: 10 }) }),
      notes: string().optional().nullable(),
      postalOrZipCode: string().min(postalCodeMin, { message: t("validation.postalCode") }),
      streetAddress1: string().min(1, { message: t("validation.address") }),
      streetAddress2: string().optional().nullable(),
    }),
    meta: object({
      homeTypePlaceholder: string().min(1, t("validation.homeType")),
      keyInfo: string(),
      willCustomerBePresent: unknown().refine(
        (value) => value !== "deselected",
        t("validation.pickOption"),
      ),
    }).superRefine((values, ctx) => {
      if (values.willCustomerBePresent === false && values.keyInfo.length === 0) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          path: ["keyInfo"],
          message: t("validation.keyInfo"),
        });
      }
    }),
  });
  return addressFormSchema;
};
